import React from 'react';
import { StyledTable, StyledTableContent, StyledTableHeader, StyledTableRow } from '../table/StyledTable';
import { useFormikContext } from 'formik';
import { IncomingACHDepositRow } from './IncomingACHDepositRow';
import { IEscrowExpectedIncomingAchData } from '../../../../types/accounting/data/IEscrowExpectedIncomingAchData';

interface IIncomingACHTableProps {
  onDelete: (id: string) => void;
  onSend: (id: string) => void;
  remove: (index: number) => void;
}
export const IncomingACHTable: React.FC<IIncomingACHTableProps> = ({ onDelete, onSend, remove }) => {
  const columns = ['Memo', 'Deposit Amount', 'Category', 'Payer Type'];
  const { values, initialValues, setFieldValue } = useFormikContext<{
    achDeposits: IEscrowExpectedIncomingAchData[];
  }>();
  const { achDeposits } = values;

  const onCancelEdit = (index: number) => {
    if (initialValues.achDeposits[index]) {
      setFieldValue(`achDeposits.${index}`, initialValues.achDeposits[index]);
    } else {
      remove(index);
    }
  };

  return (
    <StyledTable columnCount={columns.length}>
      <StyledTableHeader>
        <StyledTableRow>
          <div></div>
          {columns.map((t) => (
            <div className={'items-end p-4'} key={t}>
              {t}
            </div>
          ))}
          <div></div>
        </StyledTableRow>
      </StyledTableHeader>
      <StyledTableContent>
        {achDeposits.map((item, i) => (
          <IncomingACHDepositRow
            fieldName={'achDeposits'}
            index={i}
            remove={() => remove(i)}
            onCancelEdit={() => onCancelEdit(i)}
            onDelete={() => onDelete(item.id)}
            onSend={() => onSend(item.id)}
            newDeposit={!item.createdAt}
            achPullDeposit={achDeposits[i]}
            key={item.id ?? i}
          >
            &nbsp;
          </IncomingACHDepositRow>
        ))}
      </StyledTableContent>
    </StyledTable>
  );
};
